<h1 class="text-center text-primary"><span class="notranslate">Order</span></h1>

@if ((basketlines)?.length == 0) {
  <br/>
  <div class="alert alert-dismissible alert-primary">
    Order is empty!
  </div>
} @else {
  <form [formGroup]="orderForm" (ngSubmit)="orderForm.valid  && update()" autocomplete="off">
    <div formArrayName="orderlijn">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Product Code</th>
            <th scope="col">Brand</th>
            <th scope="col">Description</th>
            <th scope="col" class="text-right">Core</th>
            <th scope="col" class="text-right">Your Price</th>
            <th scope="col" class="text-right">Quantity</th>
            <th scope="col" class="text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          @for (line of basketlines ; track line; let i = $index) {
            <tr >
              <ng-container [formGroupName]="i">
                <td><button
                  class="btn btn-danger"
                  type="button"
                  title="Delete"
                  (click)="deleteRegel(i)"><b>X</b></button></td>
                  <td>{{line.xref}}</td>
                  <td><img src="../../../assets/{{line.merk.toLowerCase()}}.png" alt="{{line.merk}}" height="20"  ></td>
                  <td>{{line.omschrijving}}</td>
                  <td class="text-right">{{line.statiegeld}}</td>
                  <td class="text-right">{{line.verkoopprijs.toFixed(2)}}</td>
                  <td class="text-right form-group">
                    <input type="text" formControlName="qty" class="text-right" size="5" />
                  </td>
                  <td class="text-right"><label>{{getControlLabel(i, 'totaallijn').toFixed(2)}}</label></td>
                </ng-container>
              </tr>
            }
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col" class="text-right">TOTAL ITEMS</th>
              <th scope="col" class="text-right">{{totalitems.toFixed(2)}}</th>
            </tr>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col" class="text-right">TOTAL CORE</th>
              <th scope="col" class="text-right">{{totalcore.toFixed(2)}}</th>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col" class="text-right">TOTAL</th>
              <th scope="col" class="text-right">{{total.toFixed(2)}}</th>
            </tr>
          </tfoot>
        </table>
        <div class="form-group text-center">
          <button [disabled]='!orderForm.valid' class="btn btn-primary mr-2" type="submit">Update</button>
          @if (alloworderdeletion === true) {
            <button class="btn btn-danger mr-2" (click)="deleteOrder()">Delete Entire Order</button>
          }
        </div>
      </div>
      <div>
        <label for="yourreference" style="text-align:left;"><b>Your Reference</b></label><br/>
        <input class="form-control" formControlName="yourreference"  maxlength="20"/><br/>
        <label for="opmerkingen" style="text-align:left;"><b>Remarks</b></label><br/>
        <textarea class="form-control" formControlName="opmerkingen" maxlength="1000"></textarea><br/>
        <button [disabled]='!orderForm.valid' class="btn btn-success mr-2" (click)="sendOrder()" >Send Order</button>
      </div>
    </form>
  }






